import { render } from "./PagarView.vue?vue&type=template&id=18b79c48&scoped=true"
import script from "./PagarView.vue?vue&type=script&lang=js"
export * from "./PagarView.vue?vue&type=script&lang=js"

import "./PagarView.vue?vue&type=style&index=0&id=18b79c48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b79c48"]])

export default __exports__